import * as React from "react"
import { useTranslation } from 'react-i18next'
import {
    GridSeeker,
    ImgS,
    SimpleCardSeeker
} from "ui-seeker/core"

import { IMAGE } from 'app/@common/constants'


export default function AppNoDataCard() {
    const { t } = useTranslation('common')

    return <SimpleCardSeeker className="no-hr-bottom">
        <GridSeeker className="form-admin" container spacing={0}>
            <GridSeeker className="table-notifications" size={12}>
                <GridSeeker container size={12} className="center-content">
                    <GridSeeker size={2} />
                    <GridSeeker size={8}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <ImgS className="image-no-data-bounce" style={{ height: '200px', opacity: 0.5, rowGap: '15px' }} src={`${IMAGE.ASSETS}/no-data-not-css.svg`} alt="No data available" />
                        </div>
                        <div className="text-no-results">{t('common:state.noDataRetry')}</div>
                    </GridSeeker>
                    <GridSeeker size={2} />
                </GridSeeker>
            </GridSeeker>
        </GridSeeker>
    </SimpleCardSeeker>
}